import React from 'react';

import { faXmark } from '@fortawesome/pro-regular-svg-icons';

import { Button } from 'components/ui/button';

interface Props {
  name: string;
  onRemove?: () => void;
}

export function AttachmentBadge({ name, onRemove }: Props) {
  return (
    <div className="badge bg-light text-dark border d-inline-flex align-items-center gap-1">
      <span className="text-truncate" style={{ maxWidth: '12rem' }}>{name}</span>
      {onRemove && (
        <Button
          aria-label={`Remove ${name}`}
          icon={faXmark}
          size="sm"
          variant="ghost"
          onClick={onRemove}
        />
      )}
    </div>
  );
}
